/**
* @name: already-sel-user-panel
* @author: weiyong
* @date: 2023-02-21 20:40
* @description：already-sel-user-panel
* @update: 2023-02-21 20:40
*/
<template>
  <div class="already-sel-user-panel">
    <div class="user-item-record-panel">
        <div class="user-item-record" :key="index" v-for="(item,index) in alreadySelUsers">
            <user-show-item
              @delRecord="delRecord"
              :item="item"
              :hasDel="true"
              :remark="getRemark(item)"
              :icon="item.avatar"
              :value="item.id"
              :label="item.realName||item.name"/>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "already-sel-user-panel",
});
</script>

<script lang="ts" setup>
import UserShowItem from "./user-show-item.vue";

interface propTypes{
  alreadySelUsers:any
}
const props=withDefaults(defineProps<propTypes>(),{
  alreadySelUsers:{}
})
const {alreadySelUsers}=toRefs(props);

const emits = defineEmits(['delRecord']);
const delRecord=function ({item}){
  emits('delRecord', {item})
}

function getRemark (item) {
  const {
    tenantName,
    deptName,
    roleName
  } = item

  let str = [tenantName, deptName, roleName].filter(val => !!val).join('-')

  if (!str?.length) {
    str = '-'
  }

  return str
}
</script>

<style type="text/css" lang="less">

</style>
